import React from "react";
import {ButtonLinkStyle} from "../../../../Components/Inputs";
import {Allow, policyEvents} from "../../../../Components/Authorize";
import {CatalogItemImage} from "../../LoanLibrary/LoanLibraryCatalog/CatalogItemImage";
import {isRmtcAdmin} from "@/Utilities/LocalStorage/storageUtilities";
import {renderCatalogDetail} from "../../LoanLibrary/loanLibraryCatalogUtilities";
import {getLoanLibraryMediaFormatTextByValue} from "../../LoanLibrary/loanLibraryConstants";
import {convertToCurrencyFormat} from "../OwnQueue/ownQueueUtility";
import {DISPLAY_STATUS} from "./ownCatalogConstants";

interface OwnCatalogItemProps {
    id?: string;
    catalogNumber?: string;
    title?: string;
    cost?: number;
    productImageUrl?: string | null;
    objectType?: number;
    description?: string;
    orderLimit?: number;
    fileLink?: string;
    keywords?: string;
    availabilityStatus?: number;
    handleClickEdit?: () => void;
    handleClickAddToQueue?: () => void;
    [key: string]: unknown;
}

export const OwnCatalogItem = ({
                                   id,
                                   catalogNumber,
                                   title,
                                   cost,
                                   productImageUrl,
                                   objectType,
                                   description,
                                   orderLimit,
                                   fileLink,
                                   keywords,
                                   availabilityStatus,
                                   handleClickEdit,
                                   handleClickAddToQueue,
                               }: OwnCatalogItemProps) => {

    return (
        <div className="catalog-item">
            <div className="catalog-item__title-row">
                <h3 id={`title${id}`}>
                    {title}
                </h3>
                <div className="catalog-item__title-actions">
                    {
                        handleClickAddToQueue &&
                        <ButtonLinkStyle
                            label="Add to Queue"
                            name={`btnAddQueue${id}`}
                            onClick={handleClickAddToQueue}
                        />
                    }
                    {
                        handleClickEdit &&
                        <Allow policyEvent={policyEvents.MANAGE_OWN_CATALOG_ITEMS}>
                            <ButtonLinkStyle
                                label={`Edit Item`}
                                name={`btnEdit${id}`}
                                onClick={handleClickEdit}
                            />
                        </Allow>
                    }
                </div>
            </div>
            <div className="catalog-item__details-row">
                <CatalogItemImage imageUrl={productImageUrl} productName={title} />
                <div className="catalog-item__info">
                    {renderCatalogDetail(catalogNumber, "Catalog Number")}
                    {renderCatalogDetail(getLoanLibraryMediaFormatTextByValue(objectType), "Object Type")}
                    {renderCatalogDetail(description, "Description")}
                    {renderCatalogDetail(orderLimit, "Order Limit")}
                    {isRmtcAdmin() && renderCatalogDetail(convertToCurrencyFormat(cost ?? 0), "Cost")}
                    {renderCatalogDetail(fileLink, "File Link", {enableLinkParsing: true})}
                    {renderCatalogDetail(keywords, "Keywords/Tags")}
                    {isRmtcAdmin() && availabilityStatus === DISPLAY_STATUS.Disabled &&
                        renderCatalogDetail("Yes", "Is For Internal Use")
                    }
                </div>
            </div>
        </div>
    );
};
